<template>
  <div>
    <div class="step-header">
      <h2 class="step-title">Selecione os módulos que quer estudar</h2>
    </div>

    <div class="module-list-container">
      <div v-for="course in modulesByCourses" :key="course.id">
        <div class="module-list-header">
          <v-icon color="#6E7B96" class="mr-2">mdi-book-outline</v-icon>
          <span>{{ course.name }}</span>
        </div>

        <div class="module-list">
          <v-checkbox v-for="module in course.modules" :key="module.id" :label="module.name" v-model="modulesChosen"
                      :value="module.id" dense hide-details color="#7C56F6" class="module-list-item"/>
        </div>
      </div>
    </div>

    <div class="step-buttons d-flex justify-content-between">
      <v-btn rounded outlined class="btn previous-step-button dark-button" large @click="previousStep">
        <v-icon class="mr-3">mdi-arrow-left</v-icon>
        Voltar
      </v-btn>

      <v-btn rounded class="btn next-step-button primary-button" v-if="this.modulesChosen.length > 0" large
             color="#F47D3A" @click="nextStep">
        Próxima
        <v-icon class="ml-3">mdi-arrow-right</v-icon>
      </v-btn>
    </div>
  </div>
</template>
<script>

import './style.scss'
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'StepTwo',

  mounted() {
    let modulesIds = []

    if (this.scheduleCourses.length > 0) {
      this.modulesByCourses = this.scheduleCourses.map(course => {
        const modules = this.modules.filter(module => module.courseId === course.id)
        modulesIds = [...modulesIds, ...modules.map(module => module.id)]

        return {...course, modules}
      })
    } else {
      this.modulesByCourses = this.courses.filter(course => {
        return this.scheduleDisciplines.find(discipline => discipline.id === course.disciplineId)
      }).map(course => {
        const modules = this.modules.filter(module => module.courseId === course.id)
        modulesIds = [...modulesIds, ...modules.map(module => module.id)]

        return {...course, modules}
      })
    }

    if (this.scheduleModules.length === 0) {
      this.setScheduleModules(modulesIds)
    }
  },

  data() {
    return {
      modulesByCourses: []
    }
  },

  computed: {
    ...mapGetters([
      'courses',
      'modules',
      'scheduleCourses',
      'scheduleDisciplines',
      'scheduleModules'
    ]),

    modulesChosen: {
      get() {
        return this.scheduleModules
      },

      set(value) {
        this.setScheduleModules(value)
      }
    }
  },

  methods: {
    ...mapActions(['setCreationStep', 'setScheduleModules']),

    previousStep() {
      this.setCreationStep(1)
    },

    nextStep() {
      this.setCreationStep(3)
    },
  }
}
</script>
